import { makeActions } from 'redux/crudCreator/actions';

export const MODEL_NAME = 'lGAS';
export const LGAActions = makeActions(MODEL_NAME);

export const getAllLGAS = LGAActions.getAll;
export const editLGAS = LGAActions.edit;
export const createLGAS = LGAActions.create;
export const getByIdLGAS = LGAActions.getDataById;
